import ParentHTTPService from 'services/HTTPService/parent/ParentHTTPService';
import { Col, Divider } from 'antd';

import { useAppQuery } from 'services/reactQuery/useAppQuery';
import { settlementTexts } from 'consts/text';
import { ChildId } from 'types';
import { ChildSettlementComponents } from '../../ChildSettlementComponents/ChildSettlementComponents';
import { ParentCorrectionInvoices } from '../../ParentCorrectionInvoices/ParentCorrectionInvoices';
import { ParentSettlementCostSplitList } from '../../ParentSettlementCostSplitList/ParentSettlementCostSplitList';

type Props = {
    selectedYear: number;
    selectedMonth: number;
    childId: ChildId;
};

export const ParentSettlementsCorrections = ({ selectedMonth, selectedYear, childId }: Props) => {
    const yearMonth = `${selectedYear}-${selectedMonth.toString().padStart(2, '0')}`;

    const { data: childSettlement } = useAppQuery(
        'CHILD_SETTLEMENT',
        [yearMonth, childId],
        () =>
            ParentHTTPService.settlements.getChildSettlement({
                period: yearMonth,
            }),
        {},
    );
    if (!childSettlement) {
        return null;
    }

    return childSettlement.corrections
        ?.sort((a, b) => b.orderNumber - a.orderNumber)
        .map((correction) => (
            <>
                <Col key={correction.orderNumber}>
                    <ChildSettlementComponents
                        costComponentList={correction.costComponentList}
                        summary={correction.grossSummary}
                        diff={correction.grossAmountDifference}
                        title={`${correction.verified ? 'Korekta' : 'Propozycja korekty'}: ${
                            correction.orderNumber
                        }`}
                    />
                    <ParentCorrectionInvoices
                        fileName={correction.fileName ?? `Faktura korygująca ${yearMonth}`}
                        title={`Faktura dla ${correction.verified ? '' : 'propozycji'} korekty ${
                            correction.orderNumber
                        }`}
                        correctionId={correction.id}
                    />
                    <ParentSettlementCostSplitList
                        title={settlementTexts.children.costAllocation.titleCorrection}
                        period={yearMonth}
                        correctionId={correction.id}
                        childId={childId}
                    />
                </Col>
                <Divider />
            </>
        ));
};
